import React from 'react';

interface Props {
  text: string;
}

// For now it just supports bold text, images and line breaks
const Markdown: React.FC<Props> = ({ text }) => {
  const parseText = (inputText: string): JSX.Element[] => {
    const elements: JSX.Element[] = [];
    let currentIndex = 0;

    // Line breaks
    const lines = inputText.split('\n');

    lines.forEach((line, lineIndex) => {
      const regex = /\*(.*?)\*|\[(.*?)\]\((.*?)\)/g;
      let match;
      let lineStartIndex = 0;

      while ((match = regex.exec(line)) !== null) {
        if (match.index > lineStartIndex) {
          elements.push(
            <span key={`text-${currentIndex}-${lineStartIndex}`}>
              {line.substring(lineStartIndex, match.index)}
            </span>,
          );
        }

        if (match[0].startsWith('*') && match[0].endsWith('*')) {
          // Bold text
          elements.push(
            <strong key={`bold-${currentIndex}-${match.index}`}>
              {match[1]}
            </strong>,
          );
        } else if (match[0].startsWith('[') && match[0].endsWith(')')) {
          // Image
          elements.push(
            <img
              key={`img-${currentIndex}-${match.index}`}
              src={match[3]}
              alt={match[2]}
              style={{ maxWidth: '100%' }}
            />,
          );
        }

        lineStartIndex = match.index + match[0].length;
      }

      if (lineStartIndex < line.length) {
        elements.push(
          <span key={`text-${currentIndex}-${line.length}`}>
            {line.substring(lineStartIndex)}
          </span>,
        );
      }

      if (lineIndex < lines.length - 1) {
        elements.push(<br key={`br-${currentIndex}-${lineIndex}`} />);
      }

      currentIndex++;
    });

    return elements;
  };

  return <>{parseText(text)}</>;
};

export default Markdown;
